import { render, staticRenderFns } from "./CheckCloseProject.vue?vue&type=template&id=bc562fd6&scoped=true"
import script from "./CheckCloseProject.vue?vue&type=script&lang=js"
export * from "./CheckCloseProject.vue?vue&type=script&lang=js"
import style0 from "./CheckCloseProject.vue?vue&type=style&index=0&id=bc562fd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc562fd6",
  null
  
)

export default component.exports